export const searchItems = [
  // 用户组名称
  {
    label: '用户组名称',
    type: 'input',
    decorator: ['name'],
    placeholder: '请输入用户组名称' 
  }
]